module.exports = __webpack_public_path__ + "media/images/hitfun/sample.profile.232x232-e47210f3a08b5c57bcdf81cc972320fc.jpg";